import { Text } from '@gjensidige/builders-components';

import styles from './utils.module.less';

export function maybeHTMLorMarkdown(text?: string): JSX.Element | null {
  if (!text) return null;
  const isHTML = text.trim().startsWith('<') && text.trim().endsWith('>');

  return isHTML ? (
    <Text
      as="div"
      className={styles.htmlArea}
      dangerouslySetInnerHTML={{ __html: text }}
    />
  ) : (
    <Text as="div" className={styles.htmlArea}>
      <p
        dangerouslySetInnerHTML={{
          __html: text
            .replace(/__/gi, '&nbsp;')
            .replace(/--/gi, '&shy;')
            .replace(/</gi, '&lt;')
            .replace(/>/gi, '&gt;')
            .replace(/\*([^\s][^\\*]+?[^\s])\*/gi, '<strong>$1</strong>')
            .replace(/\n/gi, '<br />')
        }}
      />
    </Text>
  );
}
